const configs = {
    prod: {
        apiKey: 'AIzaSyBhBIFb2tF82x0YWa6TmkspA7khQS0Udw0',
        authDomain: 'phio-main.firebaseapp.com',
        databaseURL: 'https://phio-main.firebaseio.com',
        projectId: 'phio-main',
        storageBucket: 'phio-main.appspot.com',
        messagingSenderId: '269752456677',
        appId: '1:269752456677:web:9584326099de318a',
        measurementId: 'G-9KRV02FYP4',
        recaptchaKey: '6Lf-48opAAAAAGzoZ6Oir8_FgS5uaQcaPxe1vKDC',
    },
    staging: {
        apiKey: 'AIzaSyAjIiVHQgGCPnS7HwKqN7b79L-a_I6_33A',
        authDomain: 'phio-dev-c5d2d.firebaseapp.com',
        databaseURL: 'https://phio-dev-c5d2d.firebaseio.com',
        projectId: 'phio-dev-c5d2d',
        storageBucket: 'phio-dev-c5d2d.appspot.com',
        messagingSenderId: '831737646743',
        appId: '1:831737646743:web:17a650213a26e8ddb323d2',
        measurementId: 'G-EMGRN3GT01',
        recaptchaKey: '6Ld3UMQpAAAAAD3mbOLBqb3sdSUgUx3WuXSHMX7w',
    },
    local: {
        apiKey: 'AIzaSyBDUnNJCLRZAp9_VHzTfTTGU37j6Mjf07s',
        authDomain: 'phio-dev-c5d2d.firebaseapp.com',
        databaseURL: 'https://phio-dev-c5d2d.firebaseio.com',
        projectId: 'phio-dev-c5d2d',
        storageBucket: 'phio-dev-c5d2d.appspot.com',
        messagingSenderId: '831737646743',
        appId: '1:831737646743:web:17a650213a26e8ddb323d2',
        measurementId: 'G-EMGRN3GT01',
        recaptchaKey: '6Ld3UMQpAAAAAD3mbOLBqb3sdSUgUx3WuXSHMX7w',
    },
    playground: {
        apiKey: 'AIzaSyA9pOswwGAtpQEsUezRGBI92NctDuRQzuA',
        authDomain: 'phio-dev-c5d2d.firebaseapp.com',
        databaseURL: 'https://phio-dev-c5d2d.firebaseio.com',
        projectId: 'phio-dev-c5d2d',
        storageBucket: 'phio-dev-c5d2d.appspot.com',
        messagingSenderId: '831737646743',
        appId: '1:831737646743:web:b6fd292453483ec9b323d2',
        measurementId: 'G-JT665DM64Z',
        recaptchaKey: '6Ld3UMQpAAAAAD3mbOLBqb3sdSUgUx3WuXSHMX7w',
    },
};

export default configs;
